module.exports = __webpack_public_path__ + "static/img/zs_pic@2x.74f7a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zs_pic@2x.png
// module id = H1nw
// module chunks = 1